import React from "react";
import styled from "styled-components";
import axios from "axios";
import { UserContext } from "../../context/userContext/userContext";
import { toast } from "react-toastify";
import { useState, useEffect,useContext } from "react";
import { connect } from "react-redux";
import { loginAPI } from "../../actions";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { setLoading, setLoadingMessage } from "../../actions";
import {
  isEmailValid,
  isPasswordValid,
  isContactValid,
} from "../../utils/middleware";
import ForgetPassword from "./ForgetPassword";


const Login = (props) => {
  const { setLocalUser, getLocalUser, setUser, user } = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [password, setPassword] = useState("");
  const [forgetPassword, setForgetPassword] = useState(false);  

  // ERRORS
  const [emailError, setEmailError] = useState("");
  // const [passwordError, setPasswordError] = useState("");
  const [loginError, setLoginError] = useState("");

  //Loading
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const history = useLocation();

  const handleRedirect = (url) => {
    if (url) {
      navigate(url);
    } else {
      navigate("/");
    }
  };

  const validateEmail = (value) => {
    setEmail(value);
    let emailRes = isEmailValid(value);
    setEmailError(emailRes[1] ? emailRes[1] : "");
  };

  const validatePassword = (value) => {
    setPassword(value);
    let paswdRes = isPasswordValid(value);
    // setPasswordError(paswdRes[1] ? paswdRes[1] : "");
  };
 
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      email: email,
      password: password,
    };

    try {
      const loginResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/auth/loginUser`,
        payload
      );
      //    console.log(loginResponse.data)
      if (loginResponse.status == 200) {
        setLocalUser(loginResponse.data);
        // console.log('===============Login===============')
        // console.log(loginResponse.data)
        setIsLoading(false);
        reset();
        toast.success("Sign In Successful", {
          position: toast.POSITION.TOP_RIGHT,
        });

        handleRedirect(history.state);
      }
    } catch (error) {
      setIsLoading(false);
      const msg = error?.response?.data?.message || error?.message || 'Error Signing In';
      setLoginError(msg)
      setTimeout(() => {
        setLoginError('')
      }, 3000);
      toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
      // console.error(error);
    }
    // props.signIn(payload);
  };

  const reset = () => {
    setEmail("");
    setPassword("");
    setContact("");
  };

//   useEffect(() => {
//     if (props.errors) {
//       if (props.errors.login) {
//         setLoginError(props.errors.login);
//       }
//     }
//     // if (props.user){
//     //     props.closeLoader();
//     //     handleRedirect(props.previous_url);
//     // }
//   }, []);

  return (
    <Container>
      <Section>
        <FormSection>
          <Form>
            <h1>Welcome back!</h1>
            <form>
              {loginError.length>0 && (
                <p style={{ color: "red", margin: "-10px 0 30px 0" }}>
                  {loginError}
                </p>
              )}

              <div className="inputbox-wrap">
                <div className="inputbox">
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => validateEmail(e.target.value)}
                    required="required"
                  />
                  <label htmlFor="email">Email</label>
                </div>
                {emailError && <p>{emailError}</p>}
              </div>

              <div className="inputbox-wrap">
                <div className="inputbox">
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => validatePassword(e.target.value)}
                    required="required"
                  />
                  <label htmlFor="password">Password</label>
                </div>
                <a href="#" onClick={()=>setForgetPassword(!forgetPassword)}>Forget password?</a>
              </div>
              
              <div className="inputbox">
                <input
                  type="button"
                  className={((password && email) || (password && contact)) ? "submit-valid" : "submit-invalid"}
                  value={ isLoading? "Logging in..." : "Login" }
                  onClick={!isLoading?handleLogin:null}
                  disabled={
                    !((password && email) || (password && contact))
                      ? true
                      : false
                  }
                />
              </div>
            </form>
            <Link to="/signup">New here? <em className="newuserlink" >Sign up</em> </Link>
          </Form>
        </FormSection>
        <Hero>
          <div>
            <img src="/images/donate1.jpg" alt="SignUp" />
          </div>
        </Hero>
      </Section>
      {forgetPassword && <ForgetPassword close={()=>setForgetPassword(!forgetPassword)}/>}
    </Container>
  );
};

const Container = styled.div`
  max-width: 100%;
  padding: 20px 0;
  background: linear-gradient(#000, #fa8128, #fff);
`;

const Section = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-content: start;
  align-items: flex-start;
  justify-content: space-between;
  align-items: center;
  max-width: 1128px;
  background-color: #fff;
  border-radius: 30px;
  margin: 0 auto;
  margin-top: 80px;
  padding: 20px 0;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
  /* border: 1px solid black; */
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 90%;
  }

  @media (min-width: 1024px) {
    width: 70%;
  }
  @media (max-width: 768px) {
    width: 95%;
  }
`;

const FormSection = styled.div`
  width: 48%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  /* border: 1px solid blue; */
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Form = styled.div`
  padding: 50px;
  background: #fff;
  border-radius: 30px;
  /* border: 1px solid green; */
  & h1 {
    border-left: 5px solid #ff8c00;
    padding: 10px;
    color: #000;
    letter-spacing: 5px;
    margin-bottom: 35px;
    font-weight: bold;
    padding-left: 10px;
  }
  & .inputbox-wrap {
    & p {
      text-align: left;
      padding-left: 10px;
      color: red;
    }
    margin-bottom: 30px;
  }
  & .inputbox {
    height: 50px;
    padding: 0;
    /* border: 1px solid green; */
    position: relative;
    &:last-child {
      margin-bottom: 0;
    }
  }
  & input {
    position: relative;
    padding: 11px 5px;
    border-radius: 10px;
    font-size: 1.2em;
    border: 2px solid #000;
    outline: none;
    display: block;
    width: 95%;
    &:focus ~ label,
    &:valid ~ label {
      transform: translateX(-13px) translateY(-35px);
      font-size: 1em;
    }
  }

  & .newuserlink{
    color: #ff8c00
  }

  & label {
    position: absolute;
    top: 14px;
    left: 20px;
    font-size: 1em;
    transition: 0.6s;
    font-family: sans-serif;
  }

  & [type="button"] {
    width: 100%;
    background: #ffcd90;
    color: #fff;
    border: #fff;
    font-weight: 600;
    &.submit-invalid {
        background: #ffcd90;
    }

    &.submit-valid {
        background: #ff8c00;
    }
    &:hover {
      background: #ff8c00;
    }
  }

  & a {
    text-decoration: none !important;
    color: #080808;
    margin-top: 10px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 0 20px;
    & h1 {
      font-size: 1.5em;
    }
  }
`;

const Hero = styled.div`
  width: 50%;
  overflow: hidden;
  /* border: 1px solid red; */
  div {
    height: fit-content;
    width: 400px;
    background: #fff;
    & > img {
      height: 400px;
      border-radius: 30px;
      /* border: 1px solid blue; */
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const mapStateToProps = (state) => {
  return {
    previous_url: state.appState.previous_url,
    user: state.userState.user,
    errors: state.appState.errors,
  };
};

const mapDispatchToProps = (dispatch) => ({
  signIn: (payload) => dispatch(loginAPI(payload)),
  closeLoader: () => {
    dispatch(setLoadingMessage(null));
    dispatch(setLoading(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
